"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticEmailFailureType = void 0;
var AutomaticEmailFailureType;
(function (AutomaticEmailFailureType) {
    AutomaticEmailFailureType[AutomaticEmailFailureType["Unknown"] = 0] = "Unknown";
    AutomaticEmailFailureType[AutomaticEmailFailureType["Spam"] = 1] = "Spam";
    AutomaticEmailFailureType[AutomaticEmailFailureType["Bounce"] = 2] = "Bounce";
    AutomaticEmailFailureType[AutomaticEmailFailureType["Invalid"] = 3] = "Invalid";
    AutomaticEmailFailureType[AutomaticEmailFailureType["Timeout"] = 4] = "Timeout";
    AutomaticEmailFailureType[AutomaticEmailFailureType["DNS"] = 5] = "DNS";
    AutomaticEmailFailureType[AutomaticEmailFailureType["Server"] = 6] = "Server";
})(AutomaticEmailFailureType || (exports.AutomaticEmailFailureType = AutomaticEmailFailureType = {}));
//# sourceMappingURL=AutomaticEmailFailureType.js.map